<template>
<div>
  <div class="loader">
      <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
  </div>

<div id="profile">
<div class="row" style="justify-content: center; background:#ececec; border-radius:15px; margin:40px" >
  <div class="card perfil-nivel">
    <svg class="circle-chart" style="overflow:visible; position:absolute; z-index:1;" viewbox="0 0 33.83098862 33.83098862" width="200" height="200" xmlns="http://www.w3.org/2000/svg">
      <circle class="circle-chart__circle" :stroke-dasharray="porcentajeTotal" stroke="#ffffff" stroke-width="20" stroke-linecap="round" fill="none" cx="100" cy="100" r="95" />
      <circle class="circle-chart__circle" :stroke-dasharray="porcentaje" stroke="#02a0d0" stroke-width="10" stroke-linecap="round" fill="none" cx="100" cy="100" r="95" />
    </svg>  
    <img :src="'public/'+ perfil.avatar" style="background-color:#e0e0e0; border-radius:50%; width:200px !important" />

  </div>
        <div class="card perfil-cabecera">
    <h3 style="display:block">{{perfil.alias}}</h3>
    <p style="margin:0px">nivel</p>
    <h5>{{perfil.nivel}}</h5>
    <p style="margin:0px">completado</p>
    <h5>puntos: {{perfil.puntos}} / {{perfil.puntos_nivel}}  </h5>
      </div>

<div>
      <div class="row grid-badges" >
        <div class="container">
          <div class="row" style="justify-content: center" >
            <div  class="card card-badge"  style="cursor: pointer; height:fit-content"  >
                <img src="public/images/site/badge-activity.svg"  :style="clase_actividades" class="img img-rounded img-fluid"/>
                <h6 v-if="!ind_actividades">Completá 5 actividades </h6>
                <h6 v-if="ind_actividades"  >Súper Arkidian</h6>
            </div>
            <div  class="card card-badge"  style="cursor: pointer; height:fit-content"  >
                <img src="public/images/site/badge-challenge.svg"  :style="clase_challenges" class="img img-rounded img-fluid"/>
                <h6 v-if="!ind_challenges"  >Hacé 5 desafíos </h6>
                <h6 v-if="ind_challenges"  >Desafiante </h6>
            </div>
            <div  class="card card-badge"  style="cursor: pointer; height:fit-content"  >
                <img src="public/images/site/badge-comment.svg"  :style="clase_comentarios" class="img img-rounded img-fluid"/>
                <h6 v-if="!ind_comentarios"  >Hacé 5 comentarios </h6>
                <h6 v-if="ind_comentarios"  >Conversador</h6>
            </div>
            <div  class="card card-badge"  style="cursor: pointer; height:fit-content"  >
                <img src="public/images/site/badge-contenido.svg"  :style="clase_contenidos" class="img img-rounded img-fluid"/>
                <h6 v-if="!ind_contenidos"  >Mirá 5 videos </h6>
                <h6 v-if="ind_contenidos"  >Observador</h6>
            </div>
            <div  class="card card-badge"  style="cursor: pointer; height:fit-content"  >
                <img src="public/images/site/badge-like.svg"  :style="clase_like_challenge" class="img img-rounded img-fluid"/>
                <h6 v-if="!ind_like_challenge"  >Da 5 likes </h6>
                <h6 v-if="ind_like_challenge"  >Super Like</h6>
            </div>
          </div>
        </div>
      </div>
</div>


</div>


<section class="class-section">
    <h2 style="padding-top:50px; margin-top:50px; text-align:center">En progreso</h2>
    <div class="container">
      <div v-if="cursos_pendientes.length == 0" style="margin-top:30px">
        <h4>No hay actividades en progreso</h4>
        <img src="public/images/site/no-progress.svg" style="max-width:300px" id="challenges" alt="sin actividad"/>
      </div>
      <div class="row" style="justify-content: center" >
        <div class="container">
            <div class="row" style="justify-content: center" >
                <app-activity v-for="(activity,index) in cursos_pendientes" :activity="activity" v-bind:key ="index"> </app-activity>
            </div>
        </div>
      </div>
    </div>  
</section>


<section class="class-section">
    <h2 style="padding-top:50px; margin-top:50px; text-align:center">Últimos desafíos subidos</h2>
    <div class="container">
      <div v-if="desafios_subidos.length == 0" style="margin-top:30px; text-align:center">
        <h4>Aún no hay desafíos subidos</h4>
        <img src="public/images/site/no-challenge.svg" style="max-width:300px" id="challenges" alt="sin actividad"/>
      </div>
      <div class="row" style="justify-content: center" >
        <div class="container">
            <div class="row" style="justify-content: center" >
                <app-challenge v-for="(challenge,index) in desafios_subidos" :challenge="challenge" v-bind:key ="index"> </app-challenge>
            </div>
        </div>
      </div>
    </div>  
</section>


<section class="class-section">
    <h2 style="padding-top:50px; margin-top:50px; text-align:center">Terminados</h2>
    <div class="container">
      <div v-if="cursos_hechos.length == 0" style="margin-top:30px; text-align:center">
        <h4>No hay actividades terminadas</h4>
        <img src="public/images/site/no-finished.svg" style="max-width:300px" id="challenges" alt="sin actividad"/>
      </div>
      <div class="row" style="justify-content: center" >
        <div class="container">
            <div class="row" style="justify-content: center" >
                <app-activity v-for="(activity,index) in cursos_hechos" :activity="activity" v-bind:key ="index"> </app-activity>
            </div>
        </div>
      </div>
    </div>  
</section>

</div>

</div>
</template>


<script>
import { mapGetters } from 'vuex'
import Activities from '../activities/Activity';
import Challenges from '../challenges/Challenge';



export default {
    data: function() {
        return{
          perfil:"",
          porcentaje: null,
          porcentajeTotal: 600,
          badge_hecho:"width:150px;filter:grayscale(0)",
          badge_faltante:"width:150px;filter:grayscale(1); opacity:0.5",

          clase_like_challenge: "",
          clase_comentarios: "",
          clase_actividades:"",
          clase_challenges:"",
          clase_contenidos:"",
          badges:[],
          ind_like_challenge : false,
          ind_actividades : false,
          ind_challenges : false,
          ind_comentarios : false,
          ind_contenidos : false,
          cursos_pendientes:[],
          cursos_hechos:[],
          desafios_subidos:[]
        }
    },
    computed:{
        ...mapGetters([
            'categorias',
            'userLogged',
            'pathAPI',
            'usuarioSeleccionado'
            ]),


        },
    methods: {
       buscarPerfil() {
            var self = this
            fetch(
            self.pathAPI+"perfil_usuario.php?usuario=" +
                self.usuarioSeleccionado
                )
            .then(response => response.json())
            .then(data => {
              self.perfil = data
              self.badges = data.badges
              self.desafios_subidos = data.desafios_subidos
              self.cursos_pendientes = data.cursos_pendientes
              self.cursos_hechos = data.cursos_hechos
              self.porcentaje = ((self.perfil.puntos /self.perfil.puntos_nivel)*600)+",600"
              self.procesaBadge(data.badges)
              self.procesarDesafios()

            });
        },
        procesarDesafios(){
          for(var i = 0; i < this.desafios_subidos.length; i++){
            this.desafios_subidos[i].usuario = this.userLogged.user
          }

        },
        procesaBadge(badges){

          this.clase_like_challenge = this.badge_faltante
          this.clase_comentarios = this.badge_faltante
          this.clase_actividades =this.badge_faltante
          this.clase_challenges =this.badge_faltante
          this.clase_contenidos =this.badge_faltante

      for(var i=0;i<badges.length;i++){
        if(badges[i].badge == 'likes_challenge'){
          if(badges[i].ind_terminado == 'S'){
            this.clase_like_challenge = this.badge_hecho
            this.ind_like_challenge = true
          }
        }
        if(badges[i].badge == 'comentarios'){
          if(badges[i].ind_terminado == 'S'){
            this.clase_comentarios = this.badge_hecho
            this.ind_comentarios = true
          }
        }
        if(badges[i].badge == 'actividades'){
          if(badges[i].ind_terminado == 'S'){
            this.clase_actividades = this.badge_hecho
            this.ind_actividades = true
          }
        }
        if(badges[i].badge == 'challenges'){
          if(badges[i].ind_terminado == 'S'){
            this.clase_challenges = this.badge_hecho
            this.ind_challenges = true
          }
        }
        if(badges[i].badge == 'contenidos'){
          if(badges[i].ind_terminado == 'S'){
            this.clase_contenidos = this.badge_hecho
            this.ind_contenidos = true
          }
        }



      }


    },
    },
    mounted: function(){
        this.buscarPerfil()
        const loader = document.querySelector(".loader")
        loader.className += " hidden"


    },
    components:{
      appActivity : Activities,
      appChallenge : Challenges
    }
}
</script>

<style scoped>
#profile{
  background-image: url(/public/images/site/profile-background.svg);
  background-repeat: no-repeat;
  padding-top:100px;
  padding-bottom:100px;
  background-size: 100%;
  text-align: -webkit-center;
  display:table;
  position:relative;
  width:100%;
}

.card-badge{
  width:120px;
    background-color: #fff0 !important;
  border:0px
}



.perfil-nivel{
  border : 0px !important;
  border-radius:15px !important;
  padding:30px;
  background-color: #fff0 !important;
  min-width:100px; 
  margin:0; 
  padding:50; 
  place-items:center

}

.perfil-cabecera{
  border : 0px !important;
  border-radius:15px !important;
  padding:30px;
  background-color: #fff0 !important;
  min-width:300px; 
  margin:0; 
  padding:50; 
  place-items:center

}
.grid-badges{
  margin-top:30px;
  justify-content: center; 
  width:600px
}



@media screen and (max-width: 600px) {

.perfil-nivel{
  padding:20px;
  width:100px;
}
.grid-badges{
  width:300px;
  margin-top:0px;
}

}



.class-section{
    background-color: #ececec;
    padding-top: 0px;
    padding-bottom: 30px;
    margin-left: 40px;
    margin-right: 40px;
    border-radius:15px;
}

/**
 * 1. The `reverse` animation direction plays the animation backwards
 *    which makes it start at the stroke offset 100 which means displaying
 *    no stroke at all and animating it to the value defined in the SVG
 *    via the inline `stroke-dashoffset` attribute.
 * 2. Rotate by -90 degree to make the starting point of the
 *    stroke the top of the circle.
 * 3. Using CSS transforms on SVG elements is not supported by Internet Explorer
 *    and Edge, use the transform attribute directly on the SVG element as a
 * .  workaround (https://markus.oberlehner.net/blog/pure-css-animated-svg-circle-chart/#part-4-internet-explorer-strikes-back).
 */
 .circle-chart__circle {
  animation: circle-chart-fill 0s reverse; /* 1 */
  transform: rotate(-90deg); /* 2, 3 */
  transform-origin: center; /* 4 */
}

/**
 * 1. Rotate by -90 degree to make the starting point of the
 *    stroke the top of the circle.
 * 2. Scaling mirrors the circle to make the stroke move right
 *    to mark a positive chart value.
 * 3. Using CSS transforms on SVG elements is not supported by Internet Explorer
 *    and Edge, use the transform attribute directly on the SVG element as a
 * .  workaround (https://markus.oberlehner.net/blog/pure-css-animated-svg-circle-chart/#part-4-internet-explorer-strikes-back).
 */
.circle-chart__circle--negative {
  transform: rotate(-90deg) scale(1, -1); /* 1, 2, 3 */
}

.circle-chart__info {
  animation: circle-chart-appear 0s forwards;
  opacity: 0;
  transform: translateY(0.9em);
}

@keyframes circle-chart-fill {
  to {
    stroke-dasharray: 0 1000;
  }
}

@keyframes circle-chart-appear {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

</style>


// WEBPACK FOOTER //
// src/components/sections/MyProfile.vue